export default "/images/ae68cfac89da46978fd2af3e7937f125.avif";